import {  Box, Container, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import React, { useContext, useEffect } from "react";
import globalContext from '../context/context'
import { useTranslation } from "react-i18next";
import ForgetPassword from "../components/authentication/ForgetPassword";

function ForgetPasswordPage() {

    const { t } = useTranslation();
    const { contextData: { user, authKey }, isLoggedIn } = useContext(globalContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (isLoggedIn()) {
            navigate('/');
        }
    }, [user, authKey])


    return (
        <>
            <Box className="orderElement" sx={{ bgcolor: 'rgba(0,0,0, .2)' }}>
                <Container sx={{ justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex' }} >
                    <Paper className="orderElementPaper" sx={{ width: {xs: '95%', md: '60%'}, p: 3, bgcolor: '#fff' }}>
                        <Box sx={{fontWeight: 'bold', textAlign: 'center', fontSize: '1.5rem', pb: 3}}>Reset your password</Box>
                        <Box>
                            <ForgetPassword />
                        </Box>
                    </Paper>
                </Container>

            </Box>

        </>
    );
}

export default ForgetPasswordPage;
